import React from 'react';
import { usePopover } from 'components/Popover';
import { useMergedRefs } from 'hooks';

export interface SelectMenuContentsContainerProps {
  children?: React.ReactNode;
  className?: string;
}

/**
 * The SelectMenuContents has transitions applied to it.  This component is a wrapper
 * around the contents so that the Popper can apply its inline styles without the
 * transition affecting them.
 *
 * This component is solely used for popper positioning.  Any other kind of transforms
 * should be applied to this components children
 */
function ForwardedSelectMenuContentsContainer(
  { children, className }: SelectMenuContentsContainerProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.ReactElement | null {
  const { popoverAttributes, popoverRef, popoverStyle } = usePopover();
  const mergedRef = useMergedRefs([popoverRef, ref]);

  return (
    <div
      className={className}
      style={popoverStyle}
      ref={mergedRef}
      {...popoverAttributes}
    >
      {children}
    </div>
  );
}

const SelectMenuContentsContainer = React.forwardRef(
  ForwardedSelectMenuContentsContainer,
);

export default SelectMenuContentsContainer;
